/* eslint-disable no-unused-vars */
export enum BenefitsActionType {
  GET_BENEFITS = 'get_benefits',
  GET_BENEFITS_SUCCESS = 'get_benefits_success',
  GET_BENEFITS_FAILURE = 'get_benefits_failure',
}
